import { useState } from 'react';
import AddWordBox from '../components/AddWordBox';
import RunsView from './RunsView';
import WordBankTriage from './WordBankTriage';
import WordEngineSourcing from './WordEngineSourcing';
import './WordBankPage.css';

// Word Bank (2026-09-27): three tabs, Triage, Sourcing and History.
// The Scoring, Buckets and Related Review screens were removed (archived in
// WAW-Content-Engine/_ARCHIVE/2026-09-27-wordbank-tabs/). Triage carries the six
// scores and the Unmatched names panel. Content Audit moved to the Content tab.
// History is the sweep runs screen, renamed from Runs.
// Add word (2026-10-22): one step above the tabs, word + bucket, saved approved and scored.

type WordBankView = 'triage' | 'sourcing' | 'history';

export default function WordBankPage() {
  const [view, setView] = useState<WordBankView>('triage');
  // Bumped after an add or move, so Triage reloads and shows the word.
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="wordbank-page">
      <header className="wb-header">
        <div>
          <h1>Word Bank</h1>
          <p className="wb-sub">
            Triage, source and review the history of candidate words. Every change here writes D1 only.
            <strong> Airtable is never touched from this page.</strong>
          </p>
        </div>
        <div className="wb-viewtabs">
          <button className={view === 'triage' ? 'active' : ''} onClick={() => setView('triage')}>Triage</button>
          <button className={view === 'sourcing' ? 'active' : ''} onClick={() => setView('sourcing')}>Sourcing</button>
          <button className={view === 'history' ? 'active' : ''} onClick={() => setView('history')}>History</button>
        </div>
      </header>

      <AddWordBox onChanged={() => setReloadKey((k) => k + 1)} />

      {view === 'triage' && <WordBankTriage reloadKey={reloadKey} />}
      {view === 'sourcing' && <WordEngineSourcing />}
      {view === 'history' && <RunsView />}
    </div>
  );
}
